export default "__VITE_PUBLIC_ASSET__e8ec58d1__"